module.exports = __webpack_public_path__ + "img/pic5.0e576db1.png";